import { render, staticRenderFns } from "./GenericFieldRadio.vue?vue&type=template&id=28f2884c&scoped=true&"
import script from "./GenericFieldRadio.vue?vue&type=script&lang=js&"
export * from "./GenericFieldRadio.vue?vue&type=script&lang=js&"
import style0 from "./GenericFieldRadio.vue?vue&type=style&index=0&id=28f2884c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f2884c",
  null
  
)

export default component.exports